import RestService from './_private/RestService';
import Shop from '@models/country/Shop';
import ShopMapper from '@core/mappers/country/ShopMapper';
import IShopDto from '@core/mappers/country/dtos/IShopDto';
import BannerMapper from '@core/mappers/banners/BannerMapper';
import SmdcShopMapper from '@core/mappers/country/SmdcShopMapper';
import ISmdcShopDto from '@core/mappers/country/dtos/ISmdcShopDto';
import * as NetworkUtils from '@utils/network/NetworkUtils';

class Mappers {
    shopMapper: ShopMapper = new ShopMapper();
    bannerMapper: BannerMapper = new BannerMapper();
    smdcShopMapper: SmdcShopMapper = new SmdcShopMapper();
}

export class CountryService {
    private restService: RestService = new RestService();
    private mappers: Mappers = new Mappers();

    /**
     * @throws {RequestError}
     * @throws {Error}
     */
    public async getShops(): Promise<Shop[]> {
        const response = await NetworkUtils.processResponse(this.restService.getShops());
        return this.mappers.shopMapper.map(response.data.ClubList as IShopDto[], true);
    }

    /**
     * This shops are from separate provider and are more accurate than Comtrade shops
     * We need to obtain both the Comtrade and Smdc and remove all shops which are not
     * active in Smdc (doesn't exist in Smdc list)
     * @throws {RequestError}
     * @throws {Error}
     */
    public async getSmdcShops(): Promise<Shop[]> {
        const response = await NetworkUtils.processResponse(this.restService.getSmdcShops());
        return this.mappers.smdcShopMapper.map(response.data.data as ISmdcShopDto[], true);
    }
}

export default new CountryService();



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/services/country/CountryService.ts